import React from 'react';
import { TEAM_PAGE_LIVE } from '../config/siteFlags';

const INK = '#002A38';
const TERRA = '#0076A3';

const linkStyle = { color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: '0.8125rem' };
const head = { color: '#fff', fontSize: '0.75rem', fontWeight: 700, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.06em' };

export default function MarketingFooter() {
  return (
    <footer style={{ background: INK, padding: 'clamp(2.5rem, 5vw, 4rem) clamp(1.25rem, 4vw, 3rem)', color: 'rgba(255,255,255,0.55)' }} data-testid="marketing-footer">
      <div style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '2.5rem' }}>
        <div>
          <div style={{ display: 'inline-block', background: '#fff', borderRadius: 12, padding: '8px 12px', marginBottom: '1rem' }}>
            <img src="/chire-logo-full.png" alt="CHIRE" style={{ height: 96, objectFit: 'contain' }} />
          </div>
          <p style={{ fontSize: '0.8125rem', lineHeight: 1.7, maxWidth: 300 }}>Empower your potential. The all-in-one AI recruitment platform for assessments, interviews, and compliance.</p>
        </div>
        <div>
          <h4 style={head}>Product</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <a href="/products/assessments" style={linkStyle}>AI Assessments</a>
            <a href="/products/interviews" style={linkStyle}>AI Video Interviews</a>
            <a href="/products/screening" style={linkStyle}>Resume Screening</a>
            <a href="/products/pipeline" style={linkStyle}>Candidate Pipeline</a>
            <a href="/pricing" style={linkStyle}>Pricing</a>
          </div>
        </div>
        <div>
          <h4 style={head}>Company</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <a href="/case-study" style={linkStyle}>Case Study</a>
            <a href="/about" style={linkStyle}>About Us</a>
            {TEAM_PAGE_LIVE && <a href="/about/team" style={linkStyle} data-testid="footer-team-link">Leadership Team</a>}
            <a href="/connectwithus" style={linkStyle}>Contact</a>
          </div>
        </div>
        <div>
          <h4 style={head}>Legal</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <a href="/legal/privacy" style={linkStyle}>Privacy Policy</a>
            <a href="/legal/msa" style={linkStyle}>Terms of Service</a>
            <a href="/legal/biometric-policy" style={linkStyle}>Biometric Policy</a>
            <a href="/legal/security" style={linkStyle}>Security &amp; Trust</a>
            <a href="/ai-transparency" style={linkStyle}>AI Transparency</a>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 1100, margin: '2.5rem auto 0', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem', fontSize: '0.75rem' }}>
        <span>&copy; {new Date().getFullYear()} CHIRE by ConsultMeIn Inc. All rights reserved.</span>
        <span style={{ color: TERRA }}>Assessments | Interviews | Compliance</span>
      </div>
    </footer>
  );
}
